module.exports = __webpack_public_path__ + "img/logo-facebook.5c468038.svg";